module.exports = __webpack_public_path__ + "static/media/IconAll.ba2ba984.svg";